<template>
  <div>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col :span="24">
        <h4 class="request-panel-title">
          General
        </h4>
        <div class="request-panel">
          <el-col :span="12">
            <el-row :span="20">
              <el-col :span="6">
                <b>Date</b>
              </el-col>
              <el-col :span="18">
                <time-zone-formatter :current-time="getNewDate" />
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="6">
                <b>Type</b>
              </el-col>
              <el-col :span="18">
                {{ requestInProgress.general.type }}
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :span="20">
              <el-col :span="6">
                <b>Agent</b>
              </el-col>
              <el-col :span="18">
                {{ requestInProgress.general.requester.email }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="6">
                <b>Area</b>
              </el-col>
              <el-col :span="18">
                Customer Support
              </el-col>
            </el-row>
          </el-col>
        </div>
      </el-col>
    </el-row>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col :span="12">
        <h4 class="request-panel-title">
          Customer Information
        </h4>
        <div class="request-panel">
          <el-row :span="20">
            <el-col :span="6">
              <b>Email</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.customer.customer_email }}
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Full Name</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.customer.customer_name }}
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Phone</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.customer.customer_phone }}
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12">
        <h4 class="request-panel-title">
          Customer Address
        </h4>
        <div class="request-panel">
          <el-row :span="20">
            <el-col :span="6">
              <b>Address</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.address.customer_address_1 }}
            </el-col>
          </el-row>
          <el-row
              v-if="requestInProgress.address.customer_address_2"
              :span="20">
            <el-col :span="6">
              <b>Address 2</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.address.customer_address_2 }}
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>City</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.address.customer_city }}, {{ requestInProgress.address.customer_state }}
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Country</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.address.customer_country }}
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Zip</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.address.customer_zip }}
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-alert
        v-if="shouldShowReturnMessage(requestInProgress)"
        type="warning"
        :closable="false">
      <div>
        Important note that requests for <b>non-domestic U.S.</b> addresses will not receive a label email from UPS. Manual submission of return label required.
      </div>
    </el-alert>
    <br>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col :span="12">
        <h4 class="request-panel-title">
          Product Information
        </h4>
        <div class="request-panel">
          <el-row
              v-if="requestInProgress.general.type !== 'parts'"
              :span="20">
            <el-col :span="6">
              <b>Product</b>
            </el-col>
            <el-col :span="18">
              {{ currentProduct.description }}
            </el-col>
          </el-row>
          <el-row
              v-if="requestInProgress.general.type !== 'parts'"
              :span="20">
            <el-col :span="6">
              <b>Color</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.product.new_device_color || '--------' }}
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>{{ requestInProgress.general.type !== 'parts' ? 'Reasons' : 'Parts' }}</b>
            </el-col>
            <el-col :span="18">
              <div
                  v-for="reason in requestInProgress.reasons.reasons"
                  :key="reason.id">
                ({{ reason.quantity || 1 }})
                {{ getReason(reason.id).text }}
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12">
        <h4 class="request-panel-title">
          Request Information
        </h4>
        <div class="request-panel">
          <el-row :span="20">
            <el-col :span="6">
              <b>Retailer</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.misc.purchase_location || 'N/A' }}
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Order No.</b>
            </el-col>
            <el-col :span="18">
              {{ requestInProgress.misc.order_number || '------' }}
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Kustomer Url</b>
            </el-col>
            <el-col :span="18">
              <a
                  :href="requestInProgress.misc.zendesk_id"
                  class="request-kustomer-link"
                  target="_blank"
                  style="text-decoration: none;">
                <span>Go to kustomer</span>
              </a>
              <small>
                <span
                    style="cursor: pointer;"
                    @click="copyToClipboard">
                  <i :class="kustomerUrlCopiedText ? 'el-icon-check' : 'el-icon-copy-document'"></i> {{ kustomerUrlCopiedText ? 'Copied' : 'Copy' }}
                </span>
              </small>
              <input
                  id="copy-kustomer-url"
                  type="hidden"
                  :value="requestInProgress.misc.zendesk_id">
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Expedited</b>
            </el-col>
            <el-col :span="18">
              <i
                  class="el-icon"
                  :class="{'el-icon-success text-success': requestInProgress.misc.expedited, 'el-icon-error text-error': !requestInProgress.misc.expedited }"></i>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Return First</b>
            </el-col>
            <el-col :span="18">
              <i
                  class="el-icon"
                  :class="{'el-icon-success text-success': requestInProgress.misc.receive_first, 'el-icon-error text-error': !requestInProgress.misc.receive_first }"></i>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="6">
              <b>Return Label</b>
            </el-col>
            <el-col :span="18">
              <i
                  class="el-icon"
                  :class="{'el-icon-success text-success': requestInProgress.reasons.return_label, 'el-icon-error text-error': !requestInProgress.reasons.return_label }"></i>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row
        v-if="showShipping"
        :gutter="20"
        class="form-row">
      <el-col :span="24">
        <h4 class="request-panel-title">
          Shipping Information
        </h4>
        <div
            v-loading="loadingPrice"
            class="request-panel">
          <div v-if="price.id">
            <el-row
                v-if="!price.in_stock || price.out_of_stock"
                :gutter="20">
              <el-col :span="24">
                <el-alert
                    title="This product is out of stock."
                    type="error"
                    show-icon>
                  <span>Estimated back stock date is
                    <time-zone-formatter :current-time="price.restock_dt" />.
                  </span>
                </el-alert>
              </el-col>
            </el-row>
            <el-row
                v-else
                :gutter="20">
              <el-col :span="12">
                <el-row :span="20">
                  <el-col :span="6">
                    <b>Force Stock A</b>
                  </el-col>
                  <el-col :span="18">
                    {{ requestInProgress.misc.stock_a ? "Yes" : "No" }}
                  </el-col>
                </el-row>
                <el-row
                    v-if="price.product.description"
                    :span="20">
                  <el-col :span="6">
                    <b>Product</b>
                  </el-col>
                  <el-col :span="18">
                    {{ price.product.description }}
                  </el-col>
                </el-row>
                <el-row
                    v-if="price.sku"
                    :span="20">
                  <el-col :span="6">
                    <b>SKU</b>
                  </el-col>
                  <el-col :span="18">
                    {{ price.sku | uppercase }}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-row :span="20">
                  <el-col :span="6">
                    <b>Stock</b>
                  </el-col>
                  <el-col :span="18">
                    {{ price.stock | uppercase }}
                  </el-col>
                </el-row>
                <el-row :span="20">
                  <el-col :span="6">
                    <b>Market</b>
                  </el-col>
                  <el-col :span="18">
                    {{ price.market }}
                  </el-col>
                </el-row>
                <el-row :span="20">
                  <el-col :span="6">
                    <b>Estimated</b>
                  </el-col>
                  <el-col :span="18">
                    {{ requestInProgress.misc.expedited ? '1 working day' : '5 working days' }}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="el-divider el-divider--horizontal"></div>
    <el-alert
        v-if="isReplacement"
        type="warning"
        description="Ring Neighbors will be sent an equal or better device depending on stock availability of the device requested."
        show-icon />
    <br>
    <div class="el-input">
      <el-switch v-model="request_reviewed" />
      <label>I have verified the request information</label>
    </div>
    <div class="center-buttons">
      <el-button @click="backStep(2)">
        Back
      </el-button>
      <el-button
          :disabled="!request_reviewed"
          type="danger"
          @click="submit">
        Submit
      </el-button>
    </div>
  </div>
</template>

<script>
import { get, clone } from "lodash";
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: sharedGetters } = h("shared");
const { mapGetters: requestGetters, mapActions: requestActions } =
  h("db/requests");

export default {
  name: "CustomeRequestReviewStep",
  data() {
    return {
      kustomerUrlCopiedText: false,
      request_reviewed: false,
      loadingPrice: false,
      price: {
        market: "",
        price: 0,
        sku: "",
        price: 0,
        in_stock: true,
        out_of_stock: false,
        stock: "",
        restock_dt: "",
        device_kind: {},
      },
    };
  },
  computed: {
    faCopy() {
      return faCopy;
    },
    getNewDate() {
      let date = new Date();
      return date.toISOString();
    },
    ...sharedGetters(["products", "reasons"]),
    ...requestGetters(["requestInProgress"]),
    currentProduct() {
      return (
        this.products.find((p) => {
          return p.kind === this.requestInProgress.product.new_device_kind;
        }) || {}
      );
    },
    userFullName() {
      return `${this.requestInProgress.general.requester.first_name} ${this.requestInProgress.general.requester.last_name}`;
    },
    showShipping() {
      return (
        ["replacement", "one_off"].indexOf(
          this.requestInProgress.general.type
        ) > -1
      );
    },
    isReplacement() {
      return this.requestInProgress.general.type === "replacement";
    },
  },
  created() {
    if (this.showShipping) {
      this.loadStockInformation();
    }
  },
  methods: {
    ...requestActions(["searchShipmentDetails", "setMiscInformation"]),
    copyToClipboard() {
      let el = document.getElementById("copy-kustomer-url");
      el.setAttribute("type", "text");
      el.select();

      try {
        const successful = document.execCommand("copy");
        this.kustomerUrlCopiedText = Boolean(successful);
      } catch (err) {
        this.kustomerUrlCopiedText = false;
      }

      el.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    loadStockInformation() {
      if (this.requestInProgress.product.device_price) {
        this.price = this.requestInProgress.product.device_price;
        if (!this.price.hasOwnProperty("in_stock")) {
          this.price["in_stock"] = true;
        }
        this.setMiscInformation({
          stock: this.price.stock,
          expedited: this.requestInProgress.misc.expedited,
        });
      } else {
        let payload = {
          device_id: get(this.requestInProgress, "general.profile.deviceId"),
          country: get(this.requestInProgress, "address.customer_country"),
          kind: get(this.requestInProgress, "product.new_device_kind"),
          color: get(this.requestInProgress, "product.new_device_color"),
          stock_a: get(this.requestInProgress, "misc.stock_a"),
          request_type: get(this.requestInProgress, "general.type"),
        };
        this.searchShipmentDetails(payload)
          .then((res) => {
            let price = res.data;
            if (!price["product"]) {
              price["product"] = clone(price.kind);
              delete price.kind;
            }
            if (!price["id"]) {
              price["id"] = true;
            }
            if (!price.hasOwnProperty("in_stock")) {
              price["in_stock"] = true;
            }
            this.price = price;
            this.setMiscInformation({
              stock: price.stock,
              destination: price.market,
              price: price.price,
              sku: price.sku,
            });
            this.requestInProgress.product.device_price = price.price;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            console.log("end shipping info");
          });
      }
    },
    submit() {
      this.$emit("submit");
    },
    backStep(step) {
      this.$emit("back");
    },
    getReason(id) {
      return (
        this.reasons.find((r) => {
          return r.id === id;
        }) || {}
      );
    },
    shouldShowReturnMessage(req) {
      let cs = ["us", "gb"];
      return (
        !cs.includes(this.lowerCase(req.address.customer_country)) &&
        req.reasons.return_label
      );
    },
    lowerCase(value) {
      if (value) return value.toLowerCase();
      else return value;
    },
  },
};
</script>

<style lang="scss">
.request-panel-title {
  background: #f9f9f9;
  padding: 5px;
  color: rgba(39, 146, 236, 0.9);
}
.text-error {
  color: #f56c6c;
}
.text-success {
  color: #67c23a;
}
.request-kustomer-link {
  padding-right: 7px;
  & + span {
    visibility: hidden;
  }
  &:hover + span {
    visibility: visible;
    color: #25a0dd;
    display: inline-block;
  }
}
</style>
